// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qRj11{border:1px solid #e2e2e2;margin:0 0 24px;background:#fff;border-radius:8px;color:#2d2d2d;transition:box-shadow .3s}.qRj11:active{-webkit-tap-highlight-color:rgba(0,0,0,0);box-shadow:0 2px 14px rgba(0,0,0,.06)}@media(any-hover:hover){.qRj11:hover{box-shadow:0 2px 14px rgba(0,0,0,.06)}}.qRj11.xrnU\\+{box-shadow:0 2px 14px rgba(0,0,0,.06)}.vZgQn{display:flex;align-items:center;justify-content:space-between;padding:8px 8px 8px 16px;cursor:pointer;transition:padding .2s}.xrnU\\+ .vZgQn{padding-top:16px;padding-bottom:28px}.PCvdf{color:#2d2d2d;font-size:16px;font-weight:600;line-height:24px;transition:color .2s,font-weight .2s}.xrnU\\+ .PCvdf{color:#767676;font-weight:400}.KSz4O{transition:transform .3s}.xrnU\\+ .KSz4O{transform:rotate(180deg)}._0BcKQ{padding:0 40px 32px}@media screen and (min-width:1552px){._0BcKQ{padding-right:88px;padding-left:72px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandVoiceCard": "qRj11",
	"isCardOpened": "xrnU+",
	"row": "vZgQn",
	"title": "PCvdf",
	"button": "KSz4O",
	"body": "_0BcKQ"
};
module.exports = ___CSS_LOADER_EXPORT___;
